<template>
<div class="input-group mb-3">
    <div class="input-group-prepend">
        <span class="input-group-text" id="search-addon"><i class="fas fa-search"></i></span>
    </div>
    <input type="text" class="form-control" v-model="searchKey" @keyup="search" placeholder="Cari data anda disini" aria-label="Username" aria-describedby="search-addon">
</div>
</template>

<script>
export default {
    data() {
        return {
            searchKey: ''
        }
    },
    methods: {
        search() {
            this.$emit('searching', this.searchKey)
        }
    }
}
</script>